
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/camp/[id]",
      function () {
        return require("private-next-pages/camp/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/camp/[id]"])
      });
    }
  